export default __webpack_public_path__ + "static/ogImage4-d9fef558dac26b4dbc79fe0e70a210cc.jpg";